import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import "../styles/Football-betting.css";

const ReddyAnnaFootballPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="football-betting-page">
      <Helmet>
        <title>Reddy Anna - Football Betting ID India for EPL & UEFA</title>
        <meta
          name="description"
          content="Bet on football leagues like EPL and UEFA with Reddy Anna betting ID in India. Fast and secure access."
        />
        <script type="application/ld+json">
          {`
            {
 "@context": "https://schema.org",
 "@type": "Service",
 "name": "Reddy Anna - Football Betting ID India for EPL & UEFA",
 "url": "https://reddyannaaid.com/football-betting",
 "description": "Bet on football leagues like EPL and UEFA with Reddy Anna betting ID in India. Fast and secure access.",
 "provider": {
   "@type": "Organization",
   "name": "Reddy Anna"
 },
 "areaServed": "India"
}

          `}
        </script>
      </Helmet>
      <div className="football-betting-intro">
        <div className="football-betting-intro-content">
          <h1>
            <span>Reddy Anna Football Betting:</span> Elevate Your Betting
            Experience with Every Goal!
          </h1>
          <p>
            Welcome to Reddy Anna Football Betting, your ultimate destination
            where the passion of football meets the thrill of betting. Whether
            you're a lifelong football enthusiast or new to the world of
            betting, Reddy Anna provides a top-tier platform that brings the
            excitement of the game directly to you.
          </p>
          <div className="football-betting-cta-buttons">
            <a
              href={whatsappLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Your Demo Account
            </a>
            <a
              href={ContactLink}
              className="contactus-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="football-betting-intro-image">
          <img
            src="/football-betting.webp"
            alt="Football Betting"
            className="tennis-image"
          />
        </div>
      </div>

      <section className="football-betting-features">
        <h2>
          Why Choose <span>Reddy Anna Football Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Exclusive Reddy Anna Football ID:</strong> Get your unique
            Reddy Anna Football ID and unlock access to a variety of exciting
            football betting opportunities. Your ID is the key to a wide range
            of leagues, tournaments, and betting markets.
          </li>
          <li>
            <strong>Quick and Easy Registration:</strong> Signing up is quick
            and straightforward. Create your account and get started with
            exploring the world of football betting in no time.
          </li>
          <li>
            <strong>Download the App:</strong> Bet on football anytime, anywhere
            with the Reddy Anna Football Betting App. Stay connected to live
            updates, place your bets, and enjoy the action from the palm of your
            hand.
          </li>
          <li>
            <strong>Dedicated Customer Support:</strong> Have questions or need
            assistance? Our support team is always available via WhatsApp or
            phone to ensure your betting experience is smooth and hassle-free.
          </li>
        </ol>
        <div className="football-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="football-betting-getting-started">
        <h2>
          Getting Started with <span>Reddy Anna Football Betting</span>
        </h2>
        <ol>
          <li>
            <strong>Register Your Account:</strong> Simply visit our website or
            download the app to sign up for your exclusive Reddy Anna Football
            ID.
          </li>
          <li>
            <strong>Log In:</strong> Once you're registered, use your
            credentials to log in and explore the football betting options
            available to you.
          </li>
          <li>
            <strong>Browse Football Betting Markets:</strong> Navigate through a
            wide range of football events, leagues, and tournaments. From local
            matches to international championships, we've got it all.
          </li>
          <li>
            <strong>Place Your Bets:</strong> Choose your favorite match,
            explore various betting options, and place your bets confidently
            with the best odds.
          </li>
          <li>
            <strong>Reach Out for Support:</strong> Our dedicated customer
            service team is always here to help. Don't hesitate to get in touch
            for any queries or assistance you may need.
          </li>
        </ol>
      </section>

      <section className="football-betting-join">
        <h2>
          Join <span>Reddy Anna</span> Today!
        </h2>
        <p>
          Experience football like never before with Reddy Anna Football
          Betting. Enjoy the thrill of the game with top-notch odds, an
          easy-to-use interface, and round-the-clock support. Start your journey
          today and bet responsibly!
        </p>
        <div className="football-betting-cta-buttons">
          <a
            href={whatsappLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            className="contactus-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ReddyAnnaFootballPage;
